import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import { toast } from "react-toastify";
import Crop from '../../shared/crop';

const AddCategory = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState('');
  const [isError, setError] = useState(false);
  const [formValue, setFormValue] = useState({
    id: null,
    name: "",
    image: '',
    image_url: '',
  });

  const saveCategory = () => {
    if (
      !formValue.name ||
      !formValue.image
    ) {
      toast.error("Please Fill Out This Field", {
        autoClose: 3000,
        position: "top-center",
      });
      setError(true)
      return (false)
    } {
      setError(false)
      const pUrl = id ? API_URL.CATEGORY_UPDATE : API_URL.CATEGORY_SAVE;
      axios.post(pUrl, formValue).then((res) => {
        if (res.data.status === 1) {
          if (id) {
            toast.success("Updated", {
              autoClose: 3000,
              position: "top-center",
            });
            setTimeout(() => {
              navigate("/admin/category", { replace: true });
            }, 100);
          } else {
            resetForm();
            toast.success("Saved", { autoClose: 3000, position: "top-center" });
          }
        }
      });
    }
  };

  const resetForm = () => {
    setFormValue({
      id: null,
      name: "",
      image: "",
    });
  };

  const onEdit = () => {
    axios.post(API_URL.CATEGORY_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          image_url: res.data.data.image ? res.data.data.image : ""
        });
      }
    });
  };

  useEffect(() => {
    id && onEdit();
  }, [id]);

  const isShowError = (value) => {
    if (isError && (!value || value == '' || value == null || value == undefined)) {
      return true;
    }
    return false;
  }

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>{id ? "Edit" : "Add"} Category</h5>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <Link to={"/admin/category"} className="btn btn-secondary">
                  <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <form onSubmit={(event) => event.preventDefault()}>
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <label className={`form-label ${isShowError(formValue.name) && 'required-field'}`}>Name*</label>
                  <input
                    type="text"
                    name="name"
                    value={formValue.name}
                    className="form-control"
                    id="name"
                    onChange={(event) => {
                      setFormValue({ ...formValue, name: event.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className='form-group'>
                  <label className={`form-label ${isShowError(formValue.image) && 'required-field'}`}>Image*</label>
                  <input
                    type="file"
                    name="image"
                    value={formValue.image}
                    className="form-control"
                    id="image"
                    onChange={(event) => {
                      setFormValue({ ...formValue, image: event.target.value });
                    }}
                  />
                 <img src={imagePreview} />
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="form-group text-end">
                <button
                  type="submit"
                  onClick={saveCategory}
                  // disabled={!isValidForm()}
                  className="btn btn-primary"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddCategory;
